import useConstant from "use-constant";
import { isDesktopBrowser } from "~/utils/dom-helpers";

export function useIsDesktopBrowser() {
  return useConstant(isDesktopBrowser);
}
